import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';
import { CalendarDay } from 'further-ui/utils';
import api, { type ApiResponses } from 'lib/trpcClient';
import { UpdateCapitalActionFormValues } from '../../hooks/useCapitalActionForm';

export default function useTransactionTypes({
  capitalActionId,
  entries,
  vehicleId,
  date,
}: {
  capitalActionId?: string;
  entries: UpdateCapitalActionFormValues['entries'];
  vehicleId: string;
  date: CalendarDay;
}) {
  const getTransactionTypes =
    api.capitalAction.getTransactionTypes.useMutation();

  const result = useQuery<ApiResponses['capitalAction']['getTransactionTypes']>(
    {
      queryKey: [
        'transactionTypes',
        {
          params: {
            capitalActionId,
            vehicleId,
            entries,
            date,
          },
        },
      ],
      queryFn: async () => {
        const data = await getTransactionTypes.mutateAsync({
          capitalActionId,
          vehicleId,
          entries: entries ?? [],
          date,
        });

        return data;
      },
      enabled: !!date,
      placeholderData: keepPreviousData,
      staleTime: QUERY_STALE_TIME_MS,
      gcTime: 0,
    },
  );

  return {
    transactionTypes: result.data?.transactionTypes ?? [],
    investorsBreakdown: result.data?.investorsBreakdown ?? [],
    isLoading: result.isFetching,
  };
}
